module.exports = __webpack_public_path__ + "img/21.14641417.png";